import React, { useState } from 'react';
import styles from './AddRoommateModal.module.css';

const AddRoommateModal = ({ addedByTenantID, onClose, onAdded }) => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Roommate');

  const handleSubmit = async () => {
    const result = await addRoommate(email, role, addedByTenantID);
    alert(result.message);
    if(result) {
      onAdded();
      onClose();
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <h3>Add Roommate</h3>
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles.inputField}
        />
        <select value={role} onChange={(e) => setRole(e.target.value)} className={styles.inputField}>
          <option value="Roommate">Roommate</option>
          <option value="Cosigner">Cosigner</option>
        </select>
        <button onClick={handleSubmit} className={styles.submitBtn}>Add</button>
        <button onClick={onClose} className={styles.cancelBtn}>Cancel</button>
      </div>
    </div>
  );
};

export default AddRoommateModal;
